<!-- Header -->
<div class="cw-flex-row">
  <!-- Modul-Titel -->
  <h2>{{ headerText }}</h2>

  <!-- Toolbar -->
  <phscw-toolbar [componentIdentifier]="gridId" [componentConnection]="$any(this)" [buttonClose]="true"> </phscw-toolbar>
</div>

<!-- Grid -->
<phscw-clearing-display
  [gridId]="gridId"
  [dataLeft]="dataLeft"
  [dataRight]="dataRight"
  [compareColumns]="true"
  [comparableColumns]="comparableColumnsConfig"
  [gridDisplayedColumns]="gridDisplayedColumns"
  [entityType]="entityType">
</phscw-clearing-display>

@if (savingFailed) {
  <p class="cw-merge-error">{{ 'SHARED.CLEARING.POPUP.MERGEERROR' | translate }}</p>
}
